import { DirectionIcon } from 'app/agriculture/icons';
import './DynamicDirectionIcon.scss';
import { IconBaseProps } from 'react-icons';
import classNames from 'classnames';

interface Props {
    direction?: number | null;
}

export function DynamicDirectionIcon({
    direction,
    className,
    ...props
}: Omit<IconBaseProps, 'direction'> & Props) {
    return (
        <div className="DynamicDirectionIcon" style={{ '--direction': direction }}>
            <DirectionIcon
                {...props}
                className={classNames(
                    className,
                    direction === undefined
                        ? 'DynamicDirectionIcon__empty'
                        : 'DynamicDirectionIcon__filled',
                )}
            />
        </div>
    );
}
